import { SiteAddress } from "@graphql/api";

export const getAddressLine1WithoutUnit = (
  addressLine1: string,
  lotUnit?: string
): string => {
  if (!lotUnit) return addressLine1 ?? "";

  return addressLine1
    ? addressLine1
        .split("#")?.[0]
        .replace(/lot|unit|apt|#/gi, "")
        .trim()
    : "";
};

export const mapSiteAddress = (siteAddress?: SiteAddress): string =>
  siteAddress
    ? `${getAddressLine1WithoutUnit(siteAddress.addressLine1, siteAddress.lotUnit)}${
        siteAddress.lotUnit ? ` #${siteAddress.lotUnit}` : ""
      }, ${siteAddress.city}, ${siteAddress.state} ${siteAddress.zipCode}`
    : "";
